import axios from 'axios';
import { isAuth } from '../helper/auth';
import Swal from 'sweetalert2'
import { formatDate, formatTime } from '../helper/helper';
import { absensiImageUrl } from '../helper/config';

export const prosesAbsensi = async (imageSrc, ip_client, type = 'masuk', location = null, locationName = null) => {
    const user = isAuth();
    if (!user?.id_user) {
        throw new Error('Sesi tidak valid, silakan login ulang');
    }

    if (!location?.latitude || !location?.longitude) {
        throw new Error('Lokasi wajib diaktifkan untuk absensi');
    }

    const payload = {
        id_user: user.id_user,
        ip_akses: ip_client,
        type,
        latitude: location.latitude,
        longitude: location.longitude,
        locationName: locationName || null,
    };

    const respons = await fetch(imageSrc);
    const blob = await respons.blob();
    const formData = new FormData();
    formData.append('image', blob, 'image.jpg');
    formData.append('data', JSON.stringify(payload));

    try {
        const res = await axios.post('api/absensi', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,
        });

        const { waktuMasuk, waktuKeluar, fotoMasuk, fotoKeluar, error_code, message } = res.data;

        let jenis_absensi = 'Masuk';
        let waktu = waktuMasuk;
        let image = fotoMasuk;

        if (waktuKeluar) {
            jenis_absensi = 'Pulang';
            waktu = waktuKeluar;
            image = fotoKeluar;
        } else if (waktuMasuk) {
            jenis_absensi = 'Masuk';
            waktu = waktuMasuk;
            image = fotoMasuk;
        }

        if (error_code === 1003 || error_code === 1005 || error_code === 1004) {
            Swal.fire({
                icon: "error",
                title: "Gagal...",
                // <img> di Swal — bukan XHR, tidak kena CORS
                imageUrl: error_code === 1003 && image ? absensiImageUrl(image) : undefined,
                imageWidth: error_code === 1003 && image ? 120 : undefined,
                imageAlt: error_code === 1003 ? "Foto absensi" : undefined,
                html: `
                    <div><b>${message}</b></div>
                    ${error_code === 1003 ? `<div>${formatDate(waktu)} - <b>${formatTime(waktu)}</b></div>` : ''}
                `,
                confirmButtonText: `Tutup`,
                confirmButtonColor: "#883333",
            });
            throw new Error(message || 'Gagal absensi');
        }

        Swal.fire({
            title: `Berhasil Absen ${jenis_absensi}`,
            icon: "success",
            html: `${formatDate(waktu)} - <b>${formatTime(waktu)}</b>`,
            confirmButtonText: `Tutup`,
            confirmButtonColor: "#883333",
        });
        return res.data;
    } catch (err) {
        if (err?.response) {
            const errorMessage = err.response?.data?.message || err.message || "Terjadi kesalahan saat memproses absensi.";
            Swal.fire({
                icon: "error",
                title: "Error",
                text: Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage,
                confirmButtonText: `Tutup`,
                confirmButtonColor: "#883333",
            });
        }
        throw err;
    }
};
